import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import PortfolioSection from '../components/PortfolioSection';

export default function ProyectosPage() {
  return (
    <>
      <Header />
      <main className="bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-32 pb-2">
          <h1 className="text-4xl sm:text-5xl font-light text-neutral-900 tracking-tight" style={{ fontFamily: 'Cormorant Garamond, Georgia, serif' }} data-testid="proyectos-h1">
            Proyectos de interiorismo y arquitectura en la Riviera Maya
          </h1>
        </div>
        <PortfolioSection />
      </main>
      <Footer />
    </>
  );
}
